(() => {
  if (window.tmlEditorialReveals) return;
  window.tmlEditorialReveals = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const selector = '.tml-editorial .product-grid > li';
  const observer = new IntersectionObserver(entries => {
    let stagger = 0;
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (reduced.matches || entry.target.contains(document.activeElement)) continue;
      entry.target.animate([
        { opacity: 0, transform: 'translateY(16px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 520, delay: (stagger++ % 4) * 65, easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'backwards' });
    }
  }, { threshold: 0.04 });
  const scan = () => document.querySelectorAll(selector).forEach(tile => {
    if (seen.has(tile)) return;
    seen.add(tile);
    observer.observe(tile);
  });
  scan();
  new MutationObserver(scan).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
})();
